// extracted by mini-css-extract-plugin
export default {"wrapper":"RT-z","availablePromoMessagesLabel":"ST-z","promoMessageList":"TT-z","promoMessage":"UT-z","appliedPromoMessage":"VT-z","promoMessageAmount":"WT-z"};